import gql from 'graphql-tag';

export default gql`
    query GetActiveQueueBoxes($jobId: Int) {
      getActiveQueueBoxes(jobId: $jobId) {
        boxId
        boxDesc
        semiAllocated
        proppantId
        proppantColor
        currentProppantWeight
        fillPerc
        }
    }
`;